import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full border-t border-line bg-cream py-14 md:py-24" data-id="element-94" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-95" data-mp="1o5zvmfc0uzay">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-ivory ring-1 ring-gold" data-id="element-96" data-mp="222n156i1ixsh">
          <ShieldCheckIcon className="h-8 w-8 text-wine" aria-hidden="true" data-id="element-97" data-mp="1x2ik9fd8011q" />
        </span>

        <h2 className="mt-7 font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-98" data-mp="19coa55kacql6">
          Garantía de 7 días
        </h2>

        <p className="mt-6 text-lg text-ink md:text-xl" data-id="element-99" data-mp="1j4tym5bbwpvm">
          Queremos que puedas conocer el material con tranquilidad.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-muted md:text-lg" data-id="element-100" data-mp="1ec94f2oigark">
          Si durante los primeros 7 días consideras que no es lo que esperabas, puedes solicitar el
          reembolso dentro del período de garantía.
        </p>
      </div>
    </section>;
}